import { Calculator, User } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { cn } from "../../lib/utils";

export type SurfaceSwitcherValue = "passport" | "calculators";

const OPTIONS: Array<{
  value: SurfaceSwitcherValue;
  label: string;
  icon: typeof Calculator;
  path: string;
}> = [
  {
    value: "passport",
    label: "Passport",
    icon: User,
    path: "/dashboard?view=passport",
  },
  {
    value: "calculators",
    label: "Calculators",
    icon: Calculator,
    path: "/calculators",
  },
];

export function SurfaceSwitcher({
  active,
  className,
}: {
  active: SurfaceSwitcherValue;
  className?: string;
}) {
  const navigate = useNavigate();

  return (
    <nav
      aria-label="Switch between Passport and Calculators"
      data-testid="surface-switcher"
      className={cn(
        "inline-flex items-center gap-1 rounded-full border border-border bg-card p-1 shadow-sm",
        className,
      )}
    >
      {OPTIONS.map((option) => {
        const Icon = option.icon;
        const isActive = option.value === active;
        return (
          <button
            key={option.value}
            type="button"
            aria-current={isActive ? "page" : undefined}
            data-active={isActive}
            onClick={() => navigate(option.path)}
            className={cn(
              "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-semibold transition",
              isActive
                ? "bg-primary text-primary-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            <Icon className="h-3.5 w-3.5" />
            {option.label}
          </button>
        );
      })}
    </nav>
  );
}
